export const addElement = (id: string): HTMLElement => {
  const element = document.createElement('div')
  element.setAttribute('id', id)
  return element
}

export const removeElement = (id: string): void => {
  const element = document.getElementById(id)
  element?.remove?.()
}

export const addBodyClass = (className: string): void => document.body.classList.add(className)

export const removeBodyClass = (className: string): void => document.body.classList.remove(className)
